import { NodeWithMultipleHandles } from '../NodeWithMultipleHandles';

const TelemetryNode = (props) => {
    return <NodeWithMultipleHandles {...props} nodeType="telemetryservice" />;
};

export default TelemetryNode;
